export const FILTER_FIELDS = [
  'source',
  'medium',
  'campaign',
  'term',
  'content',
  'referrer',
  'gclid',
] as const;

export type FilterField = (typeof FILTER_FIELDS)[number];

export type FilterGroup = Partial<Record<FilterField, string>>;

export type Channel = {
  name: string;
  groups: FilterGroup[];
};

export const EMPTY_GROUP: FilterGroup = {
  source: '',
  medium: '',
  campaign: '',
  term: '',
  content: '',
  referrer: '',
  gclid: '',
};

export const CUSTOM_CHANNEL_ID = '__custom__';

export function applyChannelToGroups(channel: Channel | null): FilterGroup[] {
  if (!channel || channel.groups.length === 0) return [{ ...EMPTY_GROUP }];
  return channel.groups.map((g) => ({ ...EMPTY_GROUP, ...g }));
}

export function isEmptyGroup(g: FilterGroup): boolean {
  return FILTER_FIELDS.every((k) => !g[k]);
}

export function dropEmptyFields(g: FilterGroup): FilterGroup {
  const out: FilterGroup = {};
  for (const k of FILTER_FIELDS) {
    if (g[k]) out[k] = g[k];
  }
  return out;
}

function groupsEqual(a: FilterGroup[], b: FilterGroup[]): boolean {
  return (
    JSON.stringify(a.map(dropEmptyFields)) ===
    JSON.stringify(b.map(dropEmptyFields))
  );
}

export function matchChannelId(
  groups: FilterGroup[],
  channels: Channel[]
): string | null {
  if (groups.every(isEmptyGroup)) return '';
  const found = channels.find((c) => groupsEqual(c.groups, groups));
  return found ? found.name : null;
}
